import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { selectCurrentStore } from '../reducers/storeSlice'
import { setSellerNetworkError } from '../reducers/callSlice'
import UtmUtils from '../utils/utmUtils'
import { usePostHogAnalytics } from '@gojiraf/analytics'

const { REACT_APP_DISABLE_AGORA } = process.env

export function useEvent() {
  const navigate = useNavigate()
  const store = useSelector(selectCurrentStore)
  const dispatch = useDispatch()
  const { postHogTrackEvent } = usePostHogAnalytics()
  const { eventId } = useParams()

  async function join() {
    // Esto muestra algunos componentes de UI como el badge de la tienda, por ejemplo.
    // Porque esto no se muestra por defecto? Porque tiene ser cuando la llamada comienza?

    if (REACT_APP_DISABLE_AGORA === 'true') {
      return
    }
  }

  async function close(reason) {
    // Este atributo deberia ser un enum, cuando tengamos TypeScript.
    if (reason === 'USER CLOSED EVENT') {
      postHogTrackEvent('event-click-confirm-button-close')
    } else if (reason === 'USER REJECTED TERMS AND CONDITIONS') {
      postHogTrackEvent('event-reject-tyc')
    } else if (reason === 'USER CLOSED TAB') {
      postHogTrackEvent('event-close-browser-and-exit')
    } else if (reason === 'EVENT COUNTDOWN FINISHED') {
      console.debug('Event countdown finished, closing call')
    }

    if (REACT_APP_DISABLE_AGORA === 'true') {
      UtmUtils.navigateWithUTM({ path: `store/${store.id}/form`, navigate, location })

      return
    }

    // Esto debe dejar de escuchar la calidad de la red del vendedor.
    dispatch(setSellerNetworkError(false))

    UtmUtils.navigateWithUTM({
      path: `store/${store.id}/event/${eventId}/finished/survey`,
      navigate,
      location,
    })
  }

  return {
    join,
    close,
  }
}
